import { motion } from "framer-motion";
import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  useColorModeValue,
  Card,
  CardBody,
} from "@chakra-ui/react";
import React from "react";
import ContactForm from "../molecules/ContactForm";
import { BsWhatsapp, BsLinkedin } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

const ContactLink = ({ href, icon: Icon, label, ...props }) => (
  <Button
    w="full"
    bg="gray.100"
    color="gray.700"
    px={{ base: 6, xl: 8 }}
    _hover={{ bg: "#DD9331", color: "white" }}
    leftIcon={<Icon />}
    transition="all 0.2s"
    onClick={() => {
      window.location.href = href;
    }}
  >
    {label}
  </Button>
);
export default function ContactFormWithSocialButtons() {
  return (
    <Flex
      as="section"
      minH="100vh"
      bg={useColorModeValue("#F9F0DF", "#F9F0DF")}
      w={"full"}
      align={"center"}
      justify={"center"}
      id="contact"
      flexDir={"row"}
      px={{ base: 5, md: 16 }}
    >
      <Box
        w={"full"}
        bgGradient={{
          base: "linear(to-r, #115945, #115945)",
          md: "linear(to-r, #115945 60%, #115945 70%)",
        }}
        borderRadius="25px"
        overflow={"visible"}
      >
        <Stack
          pos={"relative"}
          direction={{ base: "column", md: "row" }}
          spacing={{ base: 4, md: 8, lg: 8 }}
          px={{ base: 0, md: 10 }}
        >
          <Stack
            spacing={{ base: 4, md: 8, lg: 20 }}
            direction={{ base: "row", md: "row" }}
            w={"100%"}
            pt={{ base: 5, md: 6 }}
            pb={{ base: 10, md: 6 }}
            justifyContent={{ base: "center", md: "start" }}
            align={{ base: "center", md: "center" }}
          >
            <motion.div
              initial={{ scale: 0.8 }}
              viewport={{ amount: 0.5 }}
              transition={{ duration: 0.5 }}
              whileInView={{
                scale: 0.9,
                transition: { duration: 0.5, ease: "easeInOut" },
              }}
            >
              <Heading
                fontSize={{
                  base: "4xl",
                  md: "6xl",
                  lg: "8xl",
                }}
                fontWeight={900}
                textTransform={"uppercase"}
                color={"#ffffff"}
                fontFamily={"'Roboto', sans-serif"}
              >
                <Box
                  textAlign={{ base: "center", md: "start" }}
                  display={{ base: "block", md: "block" }}
                >
                  let's get in touch
                </Box>

                <Box display={{ base: "none", md: "block" }}></Box>
              </Heading>
            </motion.div>
          </Stack>
          <Stack
            spacing={{ base: 4, md: 8, lg: 10 }}
            direction={{ base: "column", md: "row" }}
            w={"100%"}
          >
            <Flex
              mx={{ base: 10, md: 0 }}
              my={{ base: -8, md: -12 }}
              justify="center"
              align="center"
              w={{ base: "auto", md: "full" }}
            >
              <Card
                color={useColorModeValue("gray.700", "whiteAlpha.900")}
                justifyContent={"center"}
                flexDir={"column"}
                bg={useColorModeValue("#333333", "gray.700")}
                borderRadius="15px"
                maxW="2xl"
                h={"full"}
                shadow="xl"
                w={"100%"}
              >
                <CardBody alignContent={"center"} justifyContent={"center"}>
                  <Stack spacing={6}>
                    <Flex justify={"center"} direction={{ base: "column", lg: "row" }} gap={2}>
                      <ContactLink
                        href="mailto:nathanmls@hotmail.com"
                        icon={MdEmail}
                        label={"Email"}
                      />
                      <ContactLink
                        href="https://www.linkedin.com/in/nathanmls/"
                        icon={BsLinkedin}
                        label="LinkedIn"
                      />
                      <ContactLink
                        href="https://wa.me//31627293829"
                        icon={BsWhatsapp}
                        label="WhatsApp"
                      />
                    </Flex>

                    <Box h="1px" bg="gray.200" />

                    <ContactForm buttonbg="#DD9331" butoncolor="#ffffff" />
                  </Stack>
                </CardBody>
              </Card>
            </Flex>
          </Stack>
        </Stack>
      </Box>
    </Flex>
  );
}
